export default __webpack_public_path__ + "static/media/0007.e98dd8d5.png";